// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3323":"6c03c413","4593":"04f6976f","4898":"e13f67a1","6610":"e13f67a1","6967":"e13f67a1"}[chunkId] + ".chunk.css";
};